<template>
    <div class="quotes">
        <div class="title">見積情報</div>
        <div class="input-group">
            <label class="input-label">見積額</label>
            <input type="text" class="type-text text-right" inputmode="numeric" v-model="amount" readonly>
            <span>円</span>
        </div>
        <div class="input-group">
            <label class="input-label">消費税</label>
            <input type="text" class="type-text text-right" inputmode="numeric" v-model="tax" readonly>
            <span>円</span>
        </div>
        <div class="input-group">
            <label class="input-label">合計</label>
            <input type="text" class="type-text text-right" inputmode="numeric" v-model="amount_total" readonly>
            <span>円</span>
        </div>
        <div class="quote-resources" ref='list'>
            <p>撮影リスト</p>
            <div class='empty' v-if='nullResult'>資料が登録されていません。</div>
            <ul>
                <li v-for='(resource, index) in resources' :key='index'>
                    <img v-if='resource.type === 0' :src="resource.url">
                    <video v-if='resource.type === 1' playsinline autoplay muted loop>
                        <source :src="resource.url" type='video/mp4'>
                    </video>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import Morescroll     from '@/lib/morescroll'

    var   scrollControllerResources = null;
    export default {
        props: ['order'],
        data: function () {
            return {
                resources: [],
                total: 1,
                loadCount: 0,
                loading: false,
                amount: 0,
                tax: 0,
                amount_total: 0
            }
        },
        computed: {
            nullResult: function() {
                return this.loadCount > 0 && this.resources.length == 0;
            }
        },
        name: "Quotes",
        methods: {
            load: function () {
                if (this.total <= this.resources.length) return false;
                this.loading = true;
                this.$api
                    .getOrderQuoteResources(this.loadCount + 1, this.$route.params.id)
                    .then((res) => {
                        this.loading = false;
                        this.resources = this.resources.concat(res.data.data.results);
                        this.total = res.data.data.pagination.total;
                        this.loadCount++;
                    })
            },
            refresh: function () {
                this.resources = [];
                this.total = 1;
                this.loadCount = 0;
                this.$api.getOrderQuote(this.$route.params.id)
                    .then((res) => {
                        this.amount = res.data.data.amount;
                        this.tax = res.data.data.tax;
                        this.amount_total = this.amount + this.tax;
                    })
                    .catch(() => {
                    });
                this.load();
            },
        },
        created: function () {
            if (!this.order) this.$router.push({name: 'orderSteps'})
        },
        mounted: function () {
            this.$$.context({
                previous: 'トップへ',
                title: "ID:" + this.$route.params.id,
                previousRouteName: 'orderSteps',
            });
            scrollControllerResources = new Morescroll({
                el: this.$refs.list,
                onOverScroll: () => {
                    this.refresh();
                },
                onScrollBottom: () => {
                    this.load();
                }
            })
            this.refresh();
        },
        beforeDestroy: function() {
            if (scrollControllerResources) {
                scrollControllerResources.destroy();
            }
        }
    }
</script>

<style lang='scss'>
    .quotes {
        padding: 1em 2em;
        max-width: 480px;
        margin: auto;

        .title {
            font-size: 1.125em;
            font-weight: bold;
            text-align: center;
        }

        .error {
            color: red;
            height: 2em;
            text-align: center;
        }

        .input-group {
            margin-bottom: 1.5em;

            label {
                width: 8em;
                flex-grow: 0;
                flex-shrink: 0;
                text-align: center;
            }

            input {
                font-size: 1.5em;
                padding: .15em;
                line-height: 1;
                height: auto;
                text-align: right;
            }

            span {
                font-size: 1.5em;
                padding: 0 .25em;
            }

            &:last-child {
                margin-top: 2.5em;
            }
        }

        .show-area {
            padding: 5px;
            background-color: #eeffee;
            border: 1px solid #339933;
            font-size: 0.75em;
        }

        .btn {
            min-width: 10em;
        }
    }
</style>